import { Stack, Typography } from '@mui/material'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import React, { SyntheticEvent, useCallback, useMemo, useState } from 'react'
import { EOp, FilterModel, Nullish } from 'types'

type StringOption = Nullish<{
  value: string
  label: string
}>

export function useSharedContentTypeFilter() {
  const [fieldValue, setFieldValue] = useState<Nullish<StringOption>>(null)

  const filterValue = useMemo(() => {
    if (!fieldValue) return null
    let filter: FilterModel = {
      contentType: {
        type: 'text',
        op: EOp.contains,
        value: fieldValue.value,
      },
    }

    if (fieldValue.value === 'taskArticle' || fieldValue.value === 'careArticle') {
      filter = {
        careArticleType: {
          type: 'text',
          op: EOp.contains,
          value: fieldValue.value,
        },
      }
    }

    return filter
  }, [fieldValue])

  const options = useMemo(() => {
    return [
      { value: 'lesson', label: 'Lesson' },
      { value: 'learnArticle', label: 'Learn Article' },
      { value: 'taskArticle', label: 'Action Post' },
      { value: 'careArticle', label: 'Guide Post' },
      { value: 'note', label: 'Note' },
    ]
  }, [])

  const handleChange = useCallback((_: SyntheticEvent, newValue: StringOption) => {
    setFieldValue(newValue)
  }, [])

  const Filter = useMemo(() => {
    return (
      <Stack direction="row" alignItems="center" className="gap-8">
        <Typography>Type</Typography>

        <Autocomplete
          multiple={false}
          options={options}
          value={fieldValue}
          onChange={handleChange}
          fullWidth
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              name="role"
              InputProps={{
                ...params.InputProps,
                endAdornment: <React.Fragment>{params.InputProps.endAdornment}</React.Fragment>,
              }}
            />
          )}
        />
      </Stack>
    )
  }, [handleChange, options, fieldValue])

  return { sharedContentTypeFilter: Filter, sharedContentTypeFilterValue: filterValue }
}
